<script setup lang="ts">

</script>

<template>
  <div w-190px sm:w-360px>
    <div class="b-1 b-#6e6e6e b-solid p-[6.1px_7.5px] lg:p-[13px_16px] sm:p-[8px_10px]" row items-center rounded-30px bg-black>
      <svg xmlns="http://www.w3.org/2000/svg" shrink-0 lt-sm:size-12px width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M12 21C17.2467 21 21.5 16.7467 21.5 11.5C21.5 6.25329 17.2467 2 12 2C6.75329 2 2.5 6.25329 2.5 11.5C2.5 16.7467 6.75329 21 12 21Z" stroke="#6e6e6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22.5 22L20.5 20" stroke="#6e6e6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <InputText placeholder="Search..." w-full flex-grow-1 />
    </div>
  </div>
</template>

<style scoped lang="scss">
:deep(.p-inputtext) {
  @apply lt-sm:text-8px sm:py-1 sm:px-2 ml-6px bg-transparent text-white outline-none shadow-none;
}
</style>
